/**
 * WARN: label — fallback истории. В модалке EN/RU берётся из
 * `history.fields.Products.<field>` (затем `history.fields.common.<field>`).
 * При добавлении или изменении русской подписи обновляйте обе локали.
 */
export const productsFields = {
  pathway: { label: 'Pathway', valueType: 'relation' },
  bu: { label: 'BU', valueType: 'relation' },
  rms: { label: 'RMS', valueType: 'relation' },
  cms: { label: 'CMS', valueType: 'configIdList' },
  new_maa_submission_date: { label: 'New MAA submission date', valueType: 'date' },
  status: { label: 'Статус', valueType: 'relation' },
  type_of_product: { label: 'Type of product', valueType: 'relation' },
  trade_name_en: { label: 'Trade name ENG' },
  brand_finance_code: { label: 'Код продукта' },
  trade_name_ru: { label: 'Trade name RUS' },
  country: { label: 'Страна', valueType: 'relation' },
  inn_en: { label: 'INN/grouped name/chemical name ENG' },
  inn_ru: { label: 'INN/grouped name/chemical name RUS' },
  pack_size_en: { label: 'Pack size ENG' },
  pack_size_ru: { label: 'Pack size RUS' },
  pack_blocks: { label: 'Pack size', valueType: 'packBlocks' },
  storage_conditions_ru: { label: 'Storage conditions RUS' },
  initial_registration_date: { label: 'Initial Registration date', valueType: 'date' },
  withdrawal_informing_notification: { label: 'Product withdrawal informing/notification' },
  planned_withdrawal_date: { label: 'Planned withdrawal/divested date', valueType: 'date' },
  azd_code: { label: 'Код молекулы' },
  shelf_life_ru: { label: 'Shelf-life RUS' },
  batch_expiry_date: { label: 'Batch expiry date', valueType: 'date' },
  ean_code: { label: 'EAN Code' },
  po_entries: { label: 'PO number', valueType: 'poEntries' },
  rc_number_en: { label: 'RC number' },
  rc_number_country: { label: 'Страна RC number', valueType: 'relation' },
  rc_issue_date_en: { label: 'RC Issue date', valueType: 'date' },
  rc_reissue_date_en: { label: 'RC Reissue date', valueType: 'date' },
  rc_expiry_date_en: { label: 'RC expiry date', valueType: 'date' },
  type_rc_en: { label: 'Type RC', valueType: 'relation' },
  mah_en: { label: 'MAH EN', valueType: 'relation' },
  mah_ru: { label: 'MAH RU', valueType: 'relation' },
  restricted_access: { label: 'Доступ к карточке' },
  full_access: { label: 'Full Access / Полный доступ', valueType: 'bool' },
  product_journey: { label: 'Product Journey Timeline', valueType: 'json' },
  clinical_trials: { label: 'Clinical Trials', valueType: 'json' },
  market_access: { label: 'Market Access', valueType: 'json' },
}

/**
 * WARN: label подменяется ключами `history.fields.ProductManufacturers.<field>`.
 * При изменении русской подписи обновляйте обе локали.
 */
export const productManufacturersFields = {
  group: { label: 'Группа площадки' },
  site_id: { label: 'Площадка', valueType: 'relation' },
  name_eng: { label: 'Site name ENG' },
  name_rus: { label: 'Site name RUS' },
  address_eng: { label: 'Address ENG' },
  address_rus: { label: 'Address RUS' },
}

/** Названия групп производителей для отображения в заголовках и префиксах полей истории */
export const productManufacturerGroupLabels = {
  manufacturer: { label: 'Manufacturer' },
  primary_packaging: { label: 'Primary packaging' },
  secondary_packaging: { label: 'Secondary packaging' },
  batch_release: { label: 'Batch release' },
}

export const productManufacturerGroupFields = {
  manufacturer: {
    name_eng: { label: 'Manufacturer name (in English)' },
    name_rus: { label: 'Производитель RUS' },
    address_eng: { label: 'Manufacturer address ENG' },
    address_rus: { label: 'Manufacturer address RUS' },
    _addButton: { label: 'New manufacturer' },
  },
  primary_packaging: {
    name_eng: { label: 'Primary packaging name ENG' },
    name_rus: { label: 'Primary packaging RUS' },
    address_eng: { label: 'Primary packaging address ENG' },
    address_rus: { label: 'Primary packaging address RUS' },
    _addButton: { label: 'New primary packaging' },
  },
  secondary_packaging: {
    name_eng: { label: 'Secondary packaging name ENG' },
    name_rus: { label: 'Secondary packaging name RUS' },
    address_eng: { label: 'Secondary packaging address ENG' },
    address_rus: { label: 'Secondary packaging address RUS' },
    _addButton: { label: 'New secondary packaging' },
  },
  batch_release: {
    name_eng: { label: 'Batch release name' },
    name_rus: { label: 'Batch release RUS' },
    address_eng: { label: 'Batch release address' },
    address_rus: { label: 'Batch release address RUS' },
    _addButton: { label: 'New batch release' },
  },
}

/** WARN: label подменяется ключами `history.fields.ProductDosageForms.<field>`; поддерживайте ru/en. */
export const productDosageFormsFields = {
  dosage_form_en: { label: 'Dosage form ENG', valueType: 'relation' },
  dosage_form_ru: { label: 'Dosage form RUS', valueType: 'relation' },
}

/** WARN: label подменяется ключами `history.fields.ProductDosageFormItems.<field>`; поддерживайте ru/en. */
export const productDosageFormItemsFields = {
  strength_en: { label: 'Strength ENG' },
  strength_ru: { label: 'Strength RUS' },
}

/** WARN: label подменяется ключами `history.fields.ProductAfsApis.<field>`; поддерживайте ru/en. */
export const productAfsApisFields = {
  api_name_en: { label: 'API name' },
  api_name_ru: { label: 'API name RUS' },
}

/** WARN: label подменяется ключами `history.fields.ProductAfsApiManufacturers.<field>`; поддерживайте ru/en. */
export const productAfsApiManufacturersFields = {
  api_manufacturer_name_en: { label: 'API manufacturer name' },
  api_manufacturer_name_ru: { label: 'API manufacturer name RUS' },
  api_manufacturer_address_en: { label: 'API manufacturer address' },
  api_manufacturer_address_ru: { label: 'API manufacturer address RUS' },
}

/** WARN: label подменяется ключами `history.fields.ProductIndications.<field>`; поддерживайте ru/en. */
export const productIndicationsFields = {
  short_text_ru: { label: 'Краткое показание RUS' },
  full_text_ru: { label: 'Полное показание RUS' },
  short_text_en: { label: 'Краткое показание ENG' },
  full_text_en: { label: 'Полное показание ENG' },
  text: { label: 'Показание' },
  status: { label: 'Статус показания', valueType: 'relation' },
  sort: { label: 'Порядок' },
}

/** Подписи risk categories в истории карточки ЛП (как на форме). */
export const productRiskCategoryLabels = {
  local_ct: 'Local CT',
  eaeu_gmpc: 'EAEU GMPc',
  shelf_life: 'Shelf-life',
  samples: 'Samples',
  trade_name: 'Trade name',
}
